/* @flow */
import * as React from 'react';

import './styles/CheckboxCopy.scss';

/**
 * ## Encapsulating [Checkbox](/internal/components/Checkbox)es in `CheckboxCopy` will visually align copy elements (such as paragraphs & lists) with `Checkbox` labels, and will also style them to match a `labelNote`.
 * ### This component is utilized to add explanatory text to a `Checkbox`.
 *
 * ```example
 * <CheckboxCopy>
 *   <Checkbox label="People in this class can see and message each other" />
 *   <p>
 *    If you select this option, people at your school can also find your class.
 *   </p>
 *   <p>
 *    This class can only include people who are 13 or older.
 *   </p>
 *   <ol>
 *     <li>List item 1</li>
 *     <li>List item 2</li>
 *     <li>List item 3</li>
 *   </ol>
 *   <ul>
 *     <li>List item 1</li>
 *     <li>List item 2</li>
 *     <li>List item 3</li>
 *   </ul>
 *   <Checkbox label="Checkbox label" />
 *   <Checkbox label="Checkbox label" />
 *   <p>
 *    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget rhoncus nunc, eget
 *    commodo felis. Vestibulum mattis mi tortor, id imperdiet ex imperdiet in.
 *   </p>
 *   <Checkbox label="Checkbox label" />
 * </CheckboxCopy>
 * ```
 *
 *
 * # TODO
 * * List styling
 * * Consider reconciling with or composing [Copy](/internal/components/Copy)
 */

export default class CheckboxCopy extends React.Component<$FlowFixMeProps> {
  render() {
    return <div className="CheckboxCopy">{this.props.children}</div>;
  }
}
